'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Thumb = require('components/Thumb/Thumb');

var _Thumb2 = _interopRequireDefault(_Thumb);

var _MyPlaylistName = require('containers/MyPlaylist/components/MyPlaylistName');

var _MyPlaylistName2 = _interopRequireDefault(_MyPlaylistName);

var _TracksCount = require('components/TracksCount/TracksCount');

var _TracksCount2 = _interopRequireDefault(_TracksCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./MyPlaylistInfo.scss');

var MyPlaylistInfo = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(MyPlaylistInfo, _PureComponent);

  function MyPlaylistInfo() {
    (0, _classCallCheck3.default)(this, MyPlaylistInfo);
    return (0, _possibleConstructorReturn3.default)(this, (MyPlaylistInfo.__proto__ || (0, _getPrototypeOf2.default)(MyPlaylistInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyPlaylistInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          playlist = _props.playlist,
          className = _props.className,
          tracksCount = _props.tracksCount;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.container, className) },
        _react2.default.createElement(_Thumb2.default, {
          asBackground: true,
          defaultImageName: 'default-logo',
          fileName: playlist.thumb,
          className: styles.thumb
        }),
        _react2.default.createElement(
          'div',
          { className: styles.textContainer },
          _react2.default.createElement(_MyPlaylistName2.default, {
            textClass: styles.name,
            className: styles.title,
            playlist: playlist
          }),
          _react2.default.createElement(_TracksCount2.default, { count: tracksCount })
        )
      );
    }
  }]);
  return MyPlaylistInfo;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  playlist: _propTypes2.default.object,
  tracksCount: _propTypes2.default.number
}, _class2.defaultProps = {
  playlist: {},
  tracksCount: 0
}, _temp)) || _class);
exports.default = MyPlaylistInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyPlaylist/components/MyPlaylistInfo.js
// module id = 2163
// module chunks = 1